import axios from "axios";
import polygon_smooth from "@turf/polygon-smooth";
import dissolve from "@turf/dissolve";
import simplify from "@turf/simplify";
import GeoJsonGeometriesLookup from "geojson-geometries-lookup";
import calculate_area from "@turf/area";
import generate_uuid from "../validation/generate_uuid";
import bbox from "@turf/bbox";

import { geoServerBaseUrl } from "./baseUrl";
const SERVER_URL = geoServerBaseUrl;
const layer_polygon_id = "68f6e11ddf49504468ecbbc4";

/*
1. get_dem_by_centroid 
2. find_nearest_dem              ➜ flood_level_mdpl_meter 
3. find_flooded_point_features   ➜ flooded_point_features
4. generate_geojson_flood        ➜ geojson_flood_in_progress
5. save_flood
*/

//run_flood_from_dem
export const run_flood_from_dem = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_flood_in_progress",
        value: {
          type: "FeatureCollection",
          features: [],
        },
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "visibility_extrude",
        value: "none",
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "visibility_flood",
        value: "visible",
      },
    });
    dispatch({
      type: "genangan_update",
    });

    const state = getState();
    const { current_dem, total_dem } = state.genangan_reducer;

    let array_actions = [
      // () => dispatch(get_dem_by_centroid(body)),
      () => dispatch(get_dem_v3(body)),
      () => dispatch(find_nearest_dem(body)),
      () => dispatch(find_flooded_point_features(body)),
      () => dispatch(generate_geojson_flood(body)),
      () => dispatch(save_flood(body)),
    ];

    if (current_dem === total_dem) {
      array_actions = [
        () => dispatch(find_nearest_dem(body)),
        () => dispatch(find_flooded_point_features(body)),
        () => dispatch(generate_geojson_flood(body)),
        () => dispatch(save_flood(body)),
      ];
    }

    // const delay_ms = 100;
    const delay_ms = 0;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = async () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };
    await parent_action();
  } catch (error) {
    throw error;
  }
};

//flood_3d
export const flood_3d = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_flood_in_progress",
        value: {
          type: "FeatureCollection",
          features: [],
        },
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "visibility_extrude",
        value: "visible",
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "visibility_flood",
        value: "none",
      },
    });

    dispatch({
      type: "genangan_update",
    });

    const state = getState();
    const { current_dem, total_dem } = state.genangan_reducer;

    let array_actions = [
      // () => dispatch(get_dem_by_centroid(body)),
      () => dispatch(get_dem_v3(body)),
      () => dispatch(find_nearest_dem(body)),
      () => dispatch(find_flooded_point_features(body)),
      () => dispatch(generate_geojson_flood(body)),
    ];

    if (current_dem === total_dem) {
      array_actions = [
        () => dispatch(find_nearest_dem(body)),
        () => dispatch(find_flooded_point_features(body)),
        () => dispatch(generate_geojson_flood(body)),
      ];
    }

    // const delay_ms = 100;
    const delay_ms = 0;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = async () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };
    await parent_action();
  } catch (error) {
    throw error;
  }
};

//1. get_dem_by_centroid
/**
 * @name : get_dem_by_centroid
 * @endpoint : https://tile-dem.mapid.io/v2
 * @body : { centroid: { latitude, longitude}, radiusInMeters
 * @query : -
 * @methode : post
 */
export const get_dem_by_centroid = (body) => async (dispatch, getState) => {
  let start_time;
  let loader_interval;
  let api_done = false;
  try {
    start_time = performance.now();
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "set_loading_action",
      payload: "get_dem_by_centroid",
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_dem",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_calc",
        value: 0,
      },
    });
    const total_time = 21_000;
    const total_batches = 100;
    const batch = total_time / total_batches;
    const ppb = 100 / total_batches; //progress per batch
    let cp = 0; //current progress
    loader_interval = setInterval(() => {
      if (!api_done && cp < 100) {
        cp += ppb;
        dispatch({
          type: "set_value_genangan",
          payload: {
            key: "current_dem",
            value: Math.min(cp, 95),
          },
        });
      } else {
        clearInterval(loader_interval);
      }
    }, batch);
    const { point_flood_long, point_flood_lat } = body;
    const res = await axios.post(
      `https://tile-dem.mapid.io/v2`,
      {
        centroid: {
          latitude: point_flood_lat,
          longitude: point_flood_long,
        },
        radiusInMeters: 300,
      },
      config
    );

    api_done = true;
    clearInterval(loader_interval);
    const end_time = performance.now();
    const time_to_get = ((end_time - start_time) / 1000).toFixed(2);
    const geojson_contour_all = res?.data || {
      type: "FeatureCollection",
      features: [],
    };

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_contour_all",
        value: geojson_contour_all,
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "time_to_get",
        value: time_to_get,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "get_dem_by_centroid",
    });
    dispatch({
      type: "genangan_update",
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_dem",
        value: 100,
      },
    });
  } catch (error) {
    api_done = true;
    clearInterval(loader_interval);
    const end_time = performance.now();
    const time_to_get = ((end_time - start_time) / 1000).toFixed(2);
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "time_to_get",
        value: time_to_get,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "get_dem_by_centroid",
    });
  }
};

//2. find_nearest_dem              ➜ flood_level_mdpl_meter
export const find_nearest_dem = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "find_nearest_dem",
    });
    const { point_flood_long, point_flood_lat, flood_level_cm } = body;
    const state = getState();
    const { geojson_contour_all } = state.genangan_reducer;
    const features = geojson_contour_all?.features || [];
    const delta = 0.000018;
    const grid_min_long = point_flood_long - delta;
    const grid_max_long = point_flood_long + delta;
    const grid_min_lat = point_flood_lat - delta;
    const grid_max_lat = point_flood_lat + delta;

    let filtered_features = features.filter((feature) => {
      if (feature.geometry.type === "Point") {
        const [long, lat] = feature.geometry.coordinates;
        return (
          long >= grid_min_long &&
          long <= grid_max_long &&
          lat >= grid_min_lat &&
          lat <= grid_max_lat
        );
      }
      return false;
    });
    filtered_features.sort((a, b) => {
      const a_ = a.properties.VALUE || 0;
      const b_ = b.properties.VALUE || 0;
      return a_ - b_;
    });
    const nearest_feature = filtered_features[0];
    const nearest_feature_mdpl_meter = nearest_feature?.properties?.VALUE;

    const flood_level_mdpl_meter =
      Number(nearest_feature_mdpl_meter) + Number(flood_level_cm) / 100;

    if (body.is_use_editable) {
      const { flood_level_cm_editable, flood_level_mdpl_meter_editable } =
        state.genangan_reducer;

      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_cm",
          value: flood_level_cm_editable,
        },
      });

      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_mdpl_meter",
          value: flood_level_mdpl_meter_editable,
        },
      });
    } else {
      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_cm",
          value: flood_level_cm,
        },
      });
      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_cm_editable",
          value: flood_level_cm,
        },
      });
      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "nearest_feature_mdpl_meter",
          value: nearest_feature_mdpl_meter,
        },
      });
      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_mdpl_meter",
          value: flood_level_mdpl_meter,
        },
      });

      dispatch({
        type: "set_value_genangan",
        payload: {
          key: "flood_level_mdpl_meter_editable",
          value: flood_level_mdpl_meter,
        },
      });
    }

    dispatch({
      type: "clear_loading_action",
      payload: "find_nearest_dem",
    });
    dispatch({
      type: "set_loading_action",
      payload: "generate_geojson_flood",
    });
    dispatch({
      type: "genangan_update",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "find_nearest_dem",
    });
  }
};

//3. find_flooded_point_features   ➜ flooded_point_features
export const find_flooded_point_features = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "find_flooded_point_features",
    });
    const state = getState();
    const { geojson_contour_all, flood_level_mdpl_meter } =
      state.genangan_reducer;
    const features = geojson_contour_all?.features || [];
    const flooded_point_features = features.filter((feature) => {
      return (
        Number(feature?.properties?.VALUE) < Number(flood_level_mdpl_meter)
      );
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "flooded_point_features",
        value: flooded_point_features,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "find_flooded_point_features",
    });
    dispatch({
      type: "genangan_update",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "find_flooded_point_features",
    });
  }
};

//4. generate_geojson_flood
export const generate_geojson_flood = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_calc",
        value: 0,
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "generate_geojson_flood",
    });

    const { point_flood_long, point_flood_lat, point_flood_feature_key } = body;

    const state = getState();
    const { flooded_point_features, flood_level_cm, flood_level_mdpl_meter } =
      state.genangan_reducer;
    const { layer_id } = state.layer;

    // const grid_width = 0.0000185;

    const grid_width = 0.0000091;

    const total_count = flooded_point_features.length;
    const batch_size = 400;
    const generate_batch = (total_count, batch_size) => {
      const batches = [];
      let skip = 0;
      while (skip < total_count) {
        batches.push({
          skip: skip,
          limit: Math.min(batch_size, total_count - skip),
        });
        skip += batch_size;
      }
      return batches;
    };
    const batches = generate_batch(total_count, batch_size);
    let geojson_polygon_raw_feature = null;
    const delay_ms = 0;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));
    const process_batches = () => {
      return batches.reduce(
        (prev_promise, batch, index) =>
          prev_promise.then(() => process_batch(batch, index)),
        Promise.resolve()
      );
    };
    const process_batch = async (batch, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            const { skip, limit } = batch;
            const batch_polygon_features = flooded_point_features
              .slice(skip, skip + limit)
              .map((pointFeature) => {
                const [lon, lat] = pointFeature.geometry.coordinates;
                const squareCoords = [
                  [lon - grid_width, lat - grid_width],
                  [lon + grid_width, lat - grid_width],
                  [lon + grid_width, lat + grid_width],
                  [lon - grid_width, lat + grid_width],
                  [lon - grid_width, lat - grid_width],
                ];
                return {
                  type: "Feature",
                  properties: pointFeature.properties,
                  geometry: {
                    type: "Polygon",
                    coordinates: [squareCoords],
                  },
                };
              });
            const geojson_batch_temp = {
              type: "FeatureCollection",
              features: batch_polygon_features,
            };
            const dissolved_batch = dissolve(geojson_batch_temp);

            if (geojson_polygon_raw_feature === null) {
              geojson_polygon_raw_feature = dissolved_batch;
            } else {
              const merged_temp = {
                type: "FeatureCollection",
                features: [
                  ...(geojson_polygon_raw_feature.features || [
                    geojson_polygon_raw_feature,
                  ]),
                  ...(dissolved_batch.features || [dissolved_batch]),
                ],
              };
              geojson_polygon_raw_feature = dissolve(merged_temp);
            }

            const progress = Math.round(((index + 1) / batches.length) * 100);
            dispatch({
              type: "set_value_genangan",
              payload: {
                key: "current_calc",
                value: progress,
              },
            });
          } catch (error) {}
        };
        return core_logic();
      });
    };
    await process_batches().then(() => {});
    const glookup = new GeoJsonGeometriesLookup(geojson_polygon_raw_feature);
    const geojson_point = {
      type: "Point",
      coordinates: [point_flood_long, point_flood_lat],
    };
    const geojson_filtered = glookup.getContainers(geojson_point);
    const geojson_filtered_fix = {
      type: "FeatureCollection",
      features: geojson_filtered.features,
    };
    const tolerance = 0.000013;
    const iteration = 2;
    const options = { tolerance: tolerance, highQuality: true };
    const geojson_flood_in_progress = simplify(geojson_filtered_fix, options);
    const geojson_smooth = polygon_smooth(geojson_flood_in_progress, {
      iterations: iteration,
    });

    const feature_flood = geojson_smooth.features[0];
    const flood_area_m_square = parseFloat(
      calculate_area(feature_flood).toFixed(0)
    );
    feature_flood.key = generate_uuid();
    feature_flood.properties = {
      type_2: "banjir",
      point_flood_long,
      point_flood_lat,
      point_flood_layer_id: layer_id,
      point_flood_feature_key,
      flood_level_cm,
      flood_level_mdpl_meter,
      flood_area_m_square,
      date_run: Date.now(),
    };

    /*
    type_2: "banjir" (constant)
    point_flood_long
    point_flood_lat
    point_flood_layer_id
    point_flood_feature_key
    flood_level_cm
    flood_level_mdpl_meter
    flood_area_m_square
    date_run
    */

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "feature_flood",
        value: feature_flood,
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_flood_in_progress",
        value: geojson_smooth,
      },
    });
    dispatch({
      type: "genangan_update",
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_calc",
        value: 100,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "generate_geojson_flood",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "generate_geojson_flood",
    });
    throw error;
  }
};

//5. save_flood
export const save_flood = () => async (dispatch, getState) => {
  /*
  Push feature arcitecture v2

  
  PUSH FEATURE Documentation:
  methode: POST
  body tersimpan dalam object item, isinya:
  body : {
  geo_layer_id : geo_layer_id,
  feature: feature
  }
  */

  try {
    dispatch({
      type: "set_loading_action",
      payload: "save_flood",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    //state
    const state = getState();
    const { feature_flood } = state.genangan_reducer;
    const { layer_id, geo_layer_list } = state.layer;
    const geo_layer = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const side_table_object = geo_layer?.side_table_object || {};
    const flood_result_area_field = side_table_object?.flood_result_area_field;
    const body_push_polygon = {
      geo_layer_id: layer_polygon_id, //proyek dan layer ada di machrus
      feature: feature_flood,
    };
    await axios.post(
      SERVER_URL + "/layers/v2/push_feature",
      body_push_polygon,
      config
    );

    /*
  const res = await axios.post( SERVER_URL + "/layers/v2/edit_properties", body, config );

  const geo_layer_id = req.body.geo_layer_id;
  const feature_key = req.body.feature_key;
  const properties_key = req.body.properties_key;
  const properties_value = req.body.properties_value;
  */
    const flood_area_m_square = feature_flood?.properties?.flood_area_m_square;
    const point_flood_feature_key =
      feature_flood?.properties?.point_flood_feature_key;
    const body_edit_point_area = {
      geo_layer_id: layer_id,
      feature_key: point_flood_feature_key,
      properties_key: flood_result_area_field,
      properties_value: flood_area_m_square,
    };

    //bagian layer basic
    const res_area = await axios.post(
      SERVER_URL + "/layers/v2/edit_properties",
      body_edit_point_area,
      config
    );
    dispatch({
      type: "EDIT_PROPERTIES",
      payload: {
        ...body_edit_point_area,
        updated_at: res_area?.data?.updated_at,
        updated_by: res_area?.data?.updated_by,
      },
    });

    //key
    const body_edit_point_key_polygon = {
      geo_layer_id: layer_id,
      feature_key: point_flood_feature_key,
      properties_key: "polygon_flood_feature_key",
      properties_value: feature_flood.key,
    };
    const res_key = await axios.post(
      SERVER_URL + "/layers/v2/edit_properties",
      body_edit_point_key_polygon,
      config
    );
    dispatch({
      type: "EDIT_PROPERTIES",
      payload: {
        ...body_edit_point_key_polygon,
        updated_at: res_key?.data?.updated_at,
        updated_by: res_key?.data?.updated_by,
      },
    });
    dispatch({
      type: "status_action",
    });

    //bagian layer khusus
    const features_flood_all = geo_layer?.features_flood_all || [];
    features_flood_all.push(feature_flood);
    dispatch({
      type: "set_inside_geo_layer",
      payload: {
        geo_layer_id: layer_id,
        key: "features_flood_all",
        value: features_flood_all,
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_flood_in_progress",
        value: {
          type: "FeatureCollection",
          features: [],
        },
      },
    });
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_calc",
        value: 0,
      },
    });
    dispatch({
      type: "genangan_update",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "save_flood",
    });
  } catch (error) {}
};

//set_flood_default
/*
body = {
point_flood_feature_key,
polygon_flood_feature_key
}
*/
export const set_flood_default =
  ({ polygon_flood_feature_key, flood_area_m_square, flood_level_cm }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "set_loading_action",
        payload: "set_flood_default",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      const state = getState();
      const { layer_id, geo_layer_list, feature_key_selected } = state.layer;
      const geo_layer = geo_layer_list.find(
        (item) => item?.geo_layer?._id === layer_id
      )?.geo_layer;
      const side_table_object = geo_layer?.side_table_object || {};

      const flood_level_field = side_table_object?.flood_level_field;
      const flood_result_area_field =
        side_table_object?.flood_result_area_field;

      //feature_key
      const body_key = {
        geo_layer_id: layer_id,
        feature_key: feature_key_selected,
        properties_key: "polygon_flood_feature_key",
        properties_value: polygon_flood_feature_key,
      };
      const res_key = await axios.post(
        SERVER_URL + "/layers/v2/edit_properties",
        body_key,
        config
      );
      dispatch({
        type: "EDIT_PROPERTIES",
        payload: {
          ...body_key,
          updated_at: res_key?.data?.updated_at,
          updated_by: res_key?.data?.updated_by,
        },
      });

      //area flood
      const body_area = {
        geo_layer_id: layer_id,
        feature_key: feature_key_selected,
        properties_key: flood_result_area_field,
        properties_value: flood_area_m_square,
      };
      const res_area = await axios.post(
        SERVER_URL + "/layers/v2/edit_properties",
        body_area,
        config
      );
      dispatch({
        type: "EDIT_PROPERTIES",
        payload: {
          ...body_area,
          updated_at: res_area?.data?.updated_at,
          updated_by: res_area?.data?.updated_by,
        },
      });

      //level_cm flood
      const body_level = {
        geo_layer_id: layer_id,
        feature_key: feature_key_selected,
        properties_key: flood_level_field,
        properties_value: flood_level_cm,
      };
      const res_level = await axios.post(
        SERVER_URL + "/layers/v2/edit_properties",
        body_level,
        config
      );
      dispatch({
        type: "EDIT_PROPERTIES",
        payload: {
          ...body_level,
          updated_at: res_level?.data?.updated_at,
          updated_by: res_level?.data?.updated_by,
        },
      });

      dispatch({
        type: "genangan_update",
      });
      dispatch({
        type: "status_action",
      });
      dispatch({
        type: "clear_loading_action",
        payload: "set_flood_default",
      });
    } catch (error) {}
  };

//set_level_flood
export const set_level_flood = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "set_level_flood",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const state = getState();
    const { layer_id, geo_layer_list, feature_key_selected } = state.layer;
    const geo_layer = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    const side_table_object = geo_layer?.side_table_object || {};
    const flood_level_field = side_table_object?.flood_level_field;
    const body = {
      geo_layer_id: layer_id,
      feature_key: feature_key_selected,
      properties_key: flood_level_field,
      properties_value: value,
    };
    const res_key = await axios.post(
      SERVER_URL + "/layers/v2/edit_properties",
      body,
      config
    );
    dispatch({
      type: "EDIT_PROPERTIES",
      payload: {
        ...body,
        updated_at: res_key?.data?.updated_at,
        updated_by: res_key?.data?.updated_by,
      },
    });
    dispatch({
      type: "genangan_update",
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "set_level_flood",
    });
  } catch (error) {}
};

//delete_polygon_flood
export const delete_polygon_flood =
  ({ polygon_flood_feature_key }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: "set_loading_action",
        payload: "delete_polygon_flood",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      const state = getState();
      const { layer_id, geo_layer_list } = state.layer;

      /*
    const feature_key = req.body.feature_key;
    const geo_layer_id = req.body.geo_layer_id;
   
    */

      //api
      await axios.post(
        SERVER_URL + "/layers/delete_feature",
        {
          feature_key: polygon_flood_feature_key,
          geo_layer_id: layer_polygon_id, //proyek dan layer ada di machrus
        },
        config
      );

      //reducer genangan di dalam layer
      const geo_layer = geo_layer_list.find(
        (item) => item?.geo_layer?._id === layer_id
      )?.geo_layer;
      let features_flood_all = geo_layer?.features_flood_all || [];

      features_flood_all = features_flood_all.filter(
        (item) => item?.key !== polygon_flood_feature_key
      );

      dispatch({
        type: "set_inside_geo_layer",
        payload: {
          geo_layer_id: layer_id,
          key: "features_flood_all",
          value: features_flood_all,
        },
      });

      dispatch({
        type: "genangan_update",
      });
      dispatch({
        type: "status_action",
      });
      dispatch({
        type: "clear_loading_action",
        payload: "delete_polygon_flood",
      });
    } catch (error) {}
  };

export const get_dem_v3 = (body) => async (dispatch, getState) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    dispatch({
      type: "set_loading_action",
      payload: "get_dem_by_centroid",
    });

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_dem",
        value: 0,
      },
    });

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "current_calc",
        value: 0,
      },
    });

    const { point_flood_long, point_flood_lat } = body;

    const state = getState();
    const { total_radius_meters, total_batches } = state.genangan_reducer;

    const grid_size = Math.sqrt(total_batches);
    const delay_ms = 0;

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "total_dem",
        value: total_batches,
      },
    });

    // Calculate total coverage area in degrees
    const lat_offset_total = total_radius_meters / 111320;
    const lon_offset_total =
      total_radius_meters /
      (111320 * Math.cos((point_flood_lat * Math.PI) / 180));

    // Calculate size of each small polygon
    const lat_step = (lat_offset_total * 2) / grid_size;
    const lon_step = (lon_offset_total * 2) / grid_size;

    // Starting position (top-left corner)
    const start_lon = point_flood_long - lon_offset_total;
    const start_lat = point_flood_lat + lat_offset_total;

    // Generate array of polygon coordinates
    const polygon_batches = [];
    for (let row = 0; row < grid_size; row++) {
      for (let col = 0; col < grid_size; col++) {
        const min_lon = start_lon + col * lon_step;
        const max_lon = start_lon + (col + 1) * lon_step;
        const max_lat = start_lat - row * lat_step;
        const min_lat = start_lat - (row + 1) * lat_step;

        polygon_batches.push({
          row,
          col,
          batch_number: row * grid_size + col + 1,
          polygon: {
            type: "Polygon",
            coordinates: [
              [
                [min_lon, min_lat],
                [min_lon, max_lat],
                [max_lon, max_lat],
                [max_lon, min_lat],
                [min_lon, min_lat],
              ],
            ],
          },
        });
      }
    }

    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = async () => {
      return polygon_batches.reduce(
        (prev_promise, batch_item, index) =>
          prev_promise.then((results) =>
            child_action(batch_item, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (batch_item, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            const res = await axios.post(
              `https://tile-dem.mapid.io/v3`,
              {
                polygon: batch_item.polygon,
              },
              config
            );

            dispatch({
              type: "set_value_genangan",
              payload: {
                key: "current_dem",
                value: batch_item.batch_number,
              },
            });

            return {
              batch_number: batch_item.batch_number,
              row: batch_item.row,
              col: batch_item.col,
              data: res.data,
              success: true,
            };
          } catch (error) {
            return {
              batch_number: batch_item.batch_number,
              row: batch_item.row,
              col: batch_item.col,
              error: error.message,
              success: false,
            };
          }
        };
        return core_logic();
      });
    };

    const all_results = await parent_action().then((results) => {
      try {
        // const successful = results.filter((r) => r.success).length;
        // const failed = results.filter((r) => !r.success).length;

        return results;
      } catch (error) {
        return results;
      }
    });

    const geojson_contour_all = {
      type: "FeatureCollection",
      features: all_results
        .filter((r) => r.success && r.data?.features)
        .flatMap((r) => r.data.features),
    };

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_contour_all",
        value: geojson_contour_all,
      },
    });

    const grid_width = 0.0000091;
    const points = geojson_contour_all.features
      .filter((feature) => feature.geometry?.type === "Point")
      .map((feature) => ({
        coordinates: feature.geometry.coordinates,
        properties: feature.properties,
      }));

    const elevations = points
      .map((point) => point.properties?.VALUE)
      .filter((val) => val !== undefined && val !== null);

    const min_mdpl = elevations.length > 0 ? Math.min(...elevations) : 0;
    const max_mdpl = elevations.length > 0 ? Math.max(...elevations) : 0;

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "min_mdpl",
        value: min_mdpl,
      },
    });

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "max_mdpl",
        value: max_mdpl,
      },
    });

    const grid_features = points.map((point, index) => {
      const [lon, lat] = point.coordinates;
      const squareCoords = [
        [lon - grid_width, lat - grid_width],
        [lon + grid_width, lat - grid_width],
        [lon + grid_width, lat + grid_width],
        [lon - grid_width, lat + grid_width],
        [lon - grid_width, lat - grid_width],
      ];
      return {
        type: "Feature",
        properties: {
          ...point.properties,
          grid_id: index,
        },
        geometry: {
          type: "Polygon",
          coordinates: [squareCoords],
        },
      };
    });
    const geojson_grid_elevation = {
      type: "FeatureCollection",
      features: grid_features,
    };
    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_grid_elevation",
        value: geojson_grid_elevation,
      },
    });

    const fixed_reduction_degree = 0.0000004;
    const [min_lon, min_lat, max_lon, max_lat] = bbox(geojson_grid_elevation);

    const geojson_flood_square = {
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [
              min_lon + fixed_reduction_degree,
              min_lat + fixed_reduction_degree,
            ],
            [
              max_lon - fixed_reduction_degree,
              min_lat + fixed_reduction_degree,
            ],
            [
              max_lon - fixed_reduction_degree,
              max_lat - fixed_reduction_degree,
            ],
            [
              min_lon + fixed_reduction_degree,
              max_lat - fixed_reduction_degree,
            ],
            [
              min_lon + fixed_reduction_degree,
              min_lat + fixed_reduction_degree,
            ],
          ],
        ],
      },
    };

    dispatch({
      type: "set_value_genangan",
      payload: {
        key: "geojson_flood_square",
        value: geojson_flood_square,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_dem_by_centroid",
    });

    dispatch({
      type: "genangan_update",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_dem_by_centroid",
    });
  }
};

export const genangan_update = () => async (dispatch) => {
  dispatch({
    type: "genangan_update",
  });
};
